import { motion, type Variants } from "framer-motion";

import { CreateBrandPageHeader } from "../shared/components/header/CreateBrandPageHeader";
import { BrandsLoading } from "../shared/components/loading-icon/BrandsLoading";

export function BrandFinishCreation() {
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.8,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 15 },
    show: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
      y: 0,
    },
  };

  return (
    <motion.div
      animate="show"
      className="flex flex-col gap-10 items-center justify-center w-full h-full p-4 text-center bg-bg-primary"
      initial="hidden"
      variants={containerVariants}
    >
      <motion.div className="flex flex-col gap-3" variants={itemVariants}>
        <CreateBrandPageHeader
          description="We are setting your brand up! This will just take a moment."
          title="Registration complete"
        />
      </motion.div>

      <motion.div variants={itemVariants}>
        <BrandsLoading />
      </motion.div>
    </motion.div>
  );
}
